import React from "react";
import { Form, Input, Button, Typography, Skeleton, Tooltip } from "antd";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import styles from "../index.scss";

const { Text } = Typography;

export const renderFieldContent = (
  field,
  form,
  sectionKey,
  fieldKey,
  options
) => {
  const {
    loading,
    isFieldInEditMode,
    toggleEditMode,
    handleSave,
    handleCancel,
    formData,
  } = options;
  const fullFieldPath = [sectionKey, fieldKey];

  // Safely get field value, first from form, then from field prop, then formData
  let fieldValue;
  if (form && typeof form.getFieldValue === "function") {
    fieldValue = form.getFieldValue(fullFieldPath);
  }

  if (fieldValue === undefined) {
    fieldValue = field.value;
  }

  if (fieldValue === undefined && formData && formData[sectionKey]) {
    fieldValue = formData[sectionKey][fieldKey];
  }

  if (loading) {
    return (
      <Skeleton.Input
        className={styles["field-renderers__container"]}
        active
        size="small"
      />
    );
  }

  const isEditing = isFieldInEditMode(sectionKey, fieldKey);

  if (isEditing) {
    return (
      <div className={styles["field-renderers__container"]}>
        <Form.Item
          name={fullFieldPath}
          initialValue={field.value}
          className={styles["field-renderers__form-item"]}
        >
          <Input />
        </Form.Item>

        <div className={styles["field-renderers__actions"]}>
          <Button
            type="link"
            icon={
              <CheckOutlined
                className={styles["field-renderers__check-icon"]}
              />
            }
            size="small"
            onClick={() => handleSave(sectionKey, fieldKey)}
            className={styles["field-renderers__action-button"]}
          />
          <Button
            type="link"
            icon={
              <CloseOutlined
                className={styles["field-renderers__close-icon"]}
              />
            }
            size="small"
            onClick={() => handleCancel(sectionKey, fieldKey)}
            className={styles["field-renderers__action-button"]}
          />
        </div>
      </div>
    );
  }

  if (field?.render) {
    return field.render(formData?.[sectionKey]?.[fieldKey]);
  }
  return (
    <div className={styles["field-renderers__container"]}>
      <Tooltip title={fieldValue ?? "N/A"}>
        <Text ellipsis>{fieldValue ?? "N/A"}</Text>
      </Tooltip>

      {field?.editable && !isEditing && (
        <Button
          type="link"
          icon={<EditOutlined />}
          size="small"
          onClick={() => toggleEditMode(sectionKey, fieldKey)}
          className={`${styles["field-renderers__action-button"]} ${styles["field-renderers__edit-icon"]}`}
        />
      )}
    </div>
  );
};

export const renderFieldLabel = (key, loading) => {
  return loading ? (
    <Skeleton.Input
      className={styles["field-renderers__label-skeleton"]}
      active
      size="small"
    />
  ) : (
    <Text type="secondary">{key}</Text>
  );
};
